/**
 * Main search class.
 * Syncs search content across multiple search inputs on the same page.
 */
class MainSearch extends window.SearchForm {
  connectedCallback() {
    super.connectedCallback();

    this.allSearchInputs = document.querySelectorAll('input[type="search"]');
  }

  onFormReset(event) {
    super.onFormReset(event);

    this.keepInSync("", this.input);
  }

  /**
   * Handle input value change and sync across instances.
   * @param {Event} event
   */
  onChange(event) {
    super.onChange();

    this.keepInSync(event.target.value, this.input);
  }

  /**
   * Sync search value across all search inputs.
   * @param {string} value
   * @param {HTMLInputElement} from - The source input to exclude from sync
   */
  keepInSync(value, from) {
    this.allSearchInputs.forEach((input) => {
      if (input !== from) input.value = value;
    });
  }
}

if (!customElements.get("main-search")) {
  customElements.define("main-search", MainSearch);
}
